// const Specification = () => {
//   const specifications = [
//     {
//       title: "FOUNDATION",
//       items: ["Isolated RCC footing."],
//     },
//     {
//       title: "STRUCTURAL",
//       items: ["Earthquake resistant RCC frame"],
//     },
//     {
//       title: "ELECTRICAL",
//       items: [
//         "Concealed electrical network with reputed quality copper wires. Modular type switches and sockets.",
//       ],
//     },
//     {
//       title: "FLOORING",
//       items: ["Vitrified floor tile in Drawing/Dining & Bed rooms."],
//     },
//     {
//       title: "DOORS",
//       items: [
//         "Both side decorative laminated flush doors fitted to EPC/ Sol wood frames. Hardware & fittings in stainless steel.",
//       ],
//     },
//     {
//       title: "WINDOWS",
//       items: ["Aluminum frames and MS grills."],
//     },
//     {
//       title: "KITCHEN",
//       items: [
//         "WALL: Ceramic tiles 2' above working platform.",
//         "FLOORING: Anti skid floor tiles.",
//         "FITTINGS: Granite working platform with stainless steel sink",
//       ],
//     },
//     {
//       title: "TOILETS",
//       items: [
//         "WALL: Designer tiles up to 7' height.",
//         "FLOORING: Anti skid floor tiles.",
//         "FITTINGS: Wash basin, WC/Commode of reputed mark & all taps and fittings with designer C.P. of reputed mars",
//       ],
//     },
//     {
//       title: "WALL FINISH",
//       items: [
//         "Distemper over putty punning to interior walls & weather coat paint to exterior walls.",
//       ],
//     },
//     {
//       title: "STAIRCASE",
//       items: ["Granite/Marble staircase with steel railing."],
//     },
//     {
//       title: "WATER SUPPLY",
//       items: ["24Hours water supply withdeep Bore and Over Head Water Tank."],
//     },
//     {
//       title: "POWER SUPPLY",
//       items: [
//         "24 Hours Power supply from CESU supported with Generator Backup upto 200 watt.",
//       ],
//     },
//   ];

//   return (
//     <>
//       <div className="py-6 md:py-8 lg:py-10">
//         <div className="w-full bg-white p-6 md:p-8 border rounded-lg">
//           <div className="mx-auto">
//             {/* Heading */}
//             <h2 className="font-medium text-[#031722] tracking-[0.01em] text-lg sm:text-xl md:text-2xl lg:text-[24px] mb-1 sm:mb-2 md:mb-3 lg:mb-4">
//               LA CASA Specification
//             </h2>

//             <div className="border w-full"></div>

//             {/* Specifications List */}
//             <div className="space-y-4 mt-1 sm:mt-2 md:mt-3 lg:mt-4">
//               <div className="">
//                 {specifications.map((spec, index) => (
//                   <div key={index}>
//                     {/* Section Title */}
//                     <h3 className=" font-medium text-[#3B3B3B] tracking-[0.01em] leading-[160%] text-base sm:text-lg md:text-[18px] mb-1 sm:mb-2 md:mb-3 lg:mb-4">
//                       {spec.title}:
//                     </h3>

//                     {/* Items List */}
//                     <ul className="space-y-2 mb-1 sm:mb-2 md:mb-3 lg:mb-4">
//                       {spec.items.map((item, itemIndex) => (
//                         <li key={itemIndex} className="flex gap-3">
//                           <span className="font-normal text-[#858585] tracking-[0.01em] leading-[160%] text-sm sm:text-base md:text-[16px]">
//                             •
//                           </span>
//                           <span className="font-normal text-[#858585] tracking-[0.01em] leading-[160%] text-sm sm:text-base md:text-[16px]">
//                             {item}
//                           </span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Specification;

const Specification = ({ specification = [] }) => {
  if (specification?.length === 0) return;
  return (
    <>
      <div className="w-full bg-white p-6 md:p-8 border rounded-lg">
        <div className="mx-auto">
          {/* Heading */}
          <h2 className="font-medium text-[#031722] tracking-[0.01em] text-lg sm:text-xl md:text-2xl lg:text-[24px] mb-1 sm:mb-2 md:mb-3 lg:mb-4">
            Project Specification
          </h2>

          <div className="border w-full"></div>

          {/* Specifications List */}
          <div className="space-y-4 mt-1 sm:mt-2 md:mt-3 lg:mt-4">
            {specification.length > 0 ? (
              specification.map((spec, index) => (
                <div key={index}>
                  {/* Section Title */}
                  <h3 className="font-medium text-[#3B3B3B] tracking-[0.01em] leading-[160%] text-base sm:text-lg md:text-[18px] mb-1 sm:mb-2 md:mb-3 lg:mb-4">
                    {spec.type}:
                  </h3>

                  {/* Items List */}
                  <ul className="space-y-2 mb-1 sm:mb-2 md:mb-3 lg:mb-4">
                    {spec.descriptions?.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex gap-3">
                        <span className="font-normal text-[#858585] tracking-[0.01em] leading-[160%] text-sm sm:text-base md:text-[16px]">
                          •
                        </span>
                        <span className="font-normal text-[#858585] tracking-[0.01em] leading-[160%] text-sm sm:text-base md:text-[16px]">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500 text-sm sm:text-base md:text-[16px]">
                No specifications available.
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Specification;
